import React, { useState, useEffect } from "react";
import axios from "axios";
import { CiEdit } from "react-icons/ci";
import { MdDelete } from "react-icons/md";
import './firmalar.css'
import { toast } from "react-toastify";
import { nodeURL } from "../configUrl";
import Swal from 'sweetalert2';
import { findSimilarMatch, normalizeName } from "../utils/similarity";
import FirmaCariModal from "./firmaCari/FirmaCariModal";
const Firmalar = () => {

  const [searchTerm, setSearchTerm] = useState(""); // Arama inputu
  const [firms, setFirms] = useState([]);
  const [showForm, setShowForm] = useState(null); // "add" veya firma ID (edit) olabilir
  const [formData, setFormData] = useState({ name: "", email: "" });
  const [cariModalFirma, setCariModalFirma] = useState(null); // { id, name } | null

  const getInfos = () => {
    axios
      .get(`${nodeURL}/getFirmalar`)
      .then((response) => {
        setFirms(response.data);
      })
      .catch((error) => {
        toast.error("Firmalar yüklenirken hata oluştu!", { position: "top-right" });
      });
  };

  useEffect(() => {
    getInfos();
  }, []);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleAddFirm = () => {
    setFormData({ name: "", email: "" });
    setShowForm("add");
  };

  const handleEdit = (firm) => {
    setFormData(firm); // Seçilen firmanın verileri formda görünsün
    setShowForm(firm.id); // Güncelleme formunu göster
  };

  const handleSaveFirm = async () => {
    if (!formData.name.trim()) {
      toast.warning("Firma adı boş bırakılamaz!", { position: "top-right" });
      return;
    }

    // Türkçe karakter kontrolü
    const turkishChars = /[ığüşöçİĞÜŞÖÇ]/;
    if (turkishChars.test(formData.email)) {
      toast.error("E-posta adresinde Türkçe karakter kullanılamaz!", { position: "top-right" });
      return;
    }

    // Basit e-posta format kontrolü
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (formData.email && !emailRegex.test(formData.email)) {
      toast.error("Geçersiz e-posta adresi!", { position: "top-right" });
      return;
    }

    if (showForm === "add") {
      const similar = findSimilarMatch(formData.name, firms, (f) => f.name);
      if (similar) {
        const confirmText =
          similar.type === "exact"
            ? `"${similar.match.name}" isminde bir firma zaten kayıtlı. Yine de eklemek istiyor musunuz?`
            : `"${similar.match.name}" isimli firmaya benzer bir isim girdiniz. Yine de eklemek istiyor musunuz?`;
        const result = await Swal.fire({
          title: "Emin misiniz?",
          text: confirmText,
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Evet, ekle",
          cancelButtonText: "Vazgeç",
        });
        if (!result.isConfirmed) return;
      }

      axios
        .post(`${nodeURL}/createFirmalar`, formData)
        .then(() => {
          toast.success("Firma başarıyla eklendi!", { position: "top-right" });
          getInfos();
          setShowForm(null);
        })
        .catch(() => {
          toast.error("Ekleme sırasında hata oluştu!", { position: "top-right" });
        });
    } else {
      axios
        .put(`${nodeURL}/updateFirmalar/${formData.id}`, formData)
        .then(() => {
          toast.success("Firma başarıyla güncellendi!", { position: "top-right" });
          getInfos();
          setShowForm(null);
        })
        .catch(() => {
          toast.error("Güncelleme sırasında hata oluştu!", { position: "top-right" });
        });
    }
  };


  const handleDelete = (id) => {
    Swal.fire({
      title: 'Emin misiniz?',
      text: 'Seçilen Firma silinecek!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Evet',
      cancelButtonText: 'Vazgeç',
    }).then((result) => {
      if (result.isConfirmed) {
        axios
        .delete(`${nodeURL}/deleteFirmalar/${id}`)
        .then(() => {
          toast.success("Firma başarıyla silindi!", { position: "top-right" });
          getInfos();
        })
        .catch((error) => {
          const msg = error.response?.data?.msg || "Silme sırasında hata oluştu!";
          toast.error(msg, { position: "top-right" });
        });
      }
    });


  };

  return (
    <div
      style={{
        background: "rgba(255, 255, 255, 0.2)",
        borderRadius: "15px",
        padding: "20px",
        backdropFilter: "blur(10px)",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
      }}
    >
      {showForm ? (
        <div className="edit-form-container">
          <h2 className="edit-form-title">{showForm=='add'?'Firma Ekle':'Firma Düzenle' }  <CiEdit className="icon" size="22px" /></h2>
          <div className="edit-form">
            <label className="form-label">Firma Adı:</label>
            <input
              type="text"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              className="form-input"
            />

            <label className="form-label">E-Posta:</label>

            <input
  type="email"
  value={formData.email}
  onChange={(e) => {
    // Türkçe karakterleri kaldır
    const cleanValue = e.target.value.replace(/[ığüşöçİĞÜŞÖÇ]/g, "");
    setFormData({ ...formData, email: cleanValue });
  }}
  className="form-input"
  placeholder="(Türkçe karakter kullanmayınız)"
/>

  <label className="form-label">İlgili:</label>
<input
              type="text"
              value={formData.ilgili_kisi}
              onChange={(e) => setFormData({ ...formData, ilgili_kisi: e.target.value })}
              className="form-input"
            />

            <label className="form-label">Telefon:</label>
            <input
              type="tel"
              value={formData.phone}
              onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
              className="form-input"
            />

            <label className="form-label">Açık Adres:</label>
            <textarea
              value={formData.address}
              onChange={(e) => setFormData({ ...formData, address: e.target.value })}
              className="form-textarea"
            ></textarea>

            <div className="form-buttons">
              <button onClick={() => setShowForm(null)} className="cancel-button">
                Geri Dön
              </button>
              <button
                onClick={handleSaveFirm}
                className="save-button"
              >
                {showForm === "add" ? "Kaydet" : "Güncelle"}
              </button>
            </div>
          </div>
        </div>
      ) : (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <input
              type="text"
              placeholder="Firma Ara..."
              value={searchTerm}
              onChange={handleSearch}
              style={{
                padding: "8px",
                border: "1px solid #ccc",
                width: "300px",
                borderRadius: '5px'
              }}
            />
            <button
              onClick={handleAddFirm}
              style={{
                padding: "10px",
                background: "green",
                color: "white",
                border: "none",
                cursor: "pointer",
                marginRight: "20px",
                borderRadius: "10px",
              }}
            >
              Yeni Firma Ekle
            </button>
          </div>

          {/* Eğer firmalar boşsa bilgilendirme mesajı */}
          {firms.length === 0 ? (
            <div
              style={{
                textAlign: "center",
                marginTop: "20px",
                padding: "10px",
                background: "#f8d7da",
                color: "#721c24",
                borderRadius: "5px",
                fontSize: "16px",
              }}
            >
              Listelenecek firma bulunamadı.
            </div>
          ) : (
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr style={{ background: "#f4f4f4", textAlign: "left" }}>
                  <th style={{ padding: "10px", borderBottom: "2px solid #ddd" ,width:'60%'}}>
                    Firma Adı
                  </th>
                  <th style={{ padding: "10px", borderBottom: "2px solid #ddd" }}>
                    İletişim
                  </th>
                  <th style={{ padding: "10px", borderBottom: "2px solid #ddd" }}>
                    İşlem
                  </th>
                </tr>
              </thead>
              <tbody>
                {firms
                  .filter((firm) =>
                    normalizeName(firm.name).includes(normalizeName(searchTerm))
                  )
                  .map((firm) => (
                    <tr key={firm.id} style={{ borderBottom: "1px solid #ddd" }}>
                      <td style={{ padding: "10px" }}>{firm.name}</td>
                      <td style={{ padding: "10px" }}>{firm.email}</td>
                      <td style={{ padding: "10px" }}>
                        <button
                          className="btn btn-sm btn-outline-success me-2"
                          onClick={() => setCariModalFirma({ id: firm.id, name: firm.name })}
                        >
                          Cari Gör
                        </button>
                        <button
                          className="btn btn-sm"
                          onClick={() => handleEdit(firm)}
                        >
                          <CiEdit className="icon" size="22px" />
                        </button>
                        <button
                          onClick={() => handleDelete(firm.id)}
                          className="btn btn-sm"
                        >
                          <MdDelete className="icon" color="red" size="22px" />
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          )}
        </>
      )}

      <FirmaCariModal
        show={!!cariModalFirma}
        onClose={() => setCariModalFirma(null)}
        firmaId={cariModalFirma?.id}
        firmaAdi={cariModalFirma?.name}
      />
    </div>
  );
};

export default Firmalar;
